<!--Copy right - © 2024 tecera gmbh-->
<script>
    import DropDownButton from "./buttons/DropDownButton.svelte";
    export let user_list;
    import { available_roles,user_role } from "../scripts/auth.js";
    let permissions = ["Hydranten", "Wasserzähler","Trinkwasser"];
</script>

<table class="table table-striped table-sm" id="data_table">
    <thead id="data_table_head">
        <tr>
            <th scope="col" style="width: 40%;">E-Mail</th>
            <th scope="col" style="width: 20%; text-align: center;">Rolle</th>
            {#each permissions as permission}
                <th scope="col" style="width: 15%; text-align: center;"
                    >{permission}</th
                >
            {/each}
            <!-- Letzte Spalte hat keine Betitelung, da hier Edit und Delete abgebildet wird -->
            <th scope="col" style="width: 10%; text-align: center;"></th>
        </tr>
    </thead>

    <tbody id="customer_table_body">
        {#each user_list as user}
            {#if user != null}
                <tr
                    ><th style="vertical-align: middle;">{user.email}</th><td
                        ><div class="input-group mb-2 mt-2">
                            <DropDownButton
                                options={$available_roles}
                                bind:selected_option={user.role}
                                disabled={$user_role.rank > user.role.rank}
                            />
                        </div></td
                    >
                    <td
                        ><input
                            style="display:block; margin: auto; margin-top: 1em;"
                            type="checkbox"
                            disabled={$user_role.rank > user.role.rank}
                            checked={user.permissions.access_hymo == 1}
                            on:click={() => {
                                user.permissions.access_hymo == 1
                                    ? (user.permissions.access_hymo = 0)
                                    : (user.permissions.access_hymo = 1);
                            }}
                        /></td
                    >
                    <td
                        ><input
                            style="display:block; margin: auto; margin-top: 1em;"
                            type="checkbox"
                            disabled={$user_role.rank > user.role.rank}
                            checked={user.permissions.access_water_meter == 1}
                            on:click={() => {
                                user.permissions.access_water_meter == 1
                                    ? (user.permissions.access_water_meter = 0)
                                    : (user.permissions.access_water_meter = 1);
                            }}
                        /></td
                    >
                    <td
                    ><input
                        style="display:block; margin: auto; margin-top: 1em;"
                        type="checkbox"
                        disabled={$user_role.rank > user.role.rank}
                        checked={user.permissions.access_drinking_water == 1}
                        on:click={() => {
                            user.permissions.access_drinking_water == 1
                                ? (user.permissions.access_drinking_water = 0)
                                : (user.permissions.access_drinking_water = 1);
                        }}
                    /></td
                >

                    <td
                        ><div>
                            <button
                                on:click={() => {
                                    user = null;
                                }}
                                type="button"
                                class="primary-color btn btn-normal btn-transparent btn-block pt-2"
                                disabled={$user_role.rank > user.role.rank}
                                ><i
                                    class="fa fa-trash-can"
                                ></i></button
                            >
                        </div></td
                    ></tr
                >
            {/if}
        {/each}
    </tbody>
</table>
